/**
 * @file 顶部菜单
 * @author yangwei(yangwei14@baidu.com)
 */
import _ from 'lodash';

import client from '../../client';
import {addEvent} from '../../common/util';
// IIFE
import '../../common/user';
import {queryDom, addActiveClass, isReadyPage, isZH} from '../../console/common/utils';

function active() {
    if (isReadyPage()) {
        return;
    }

    client.getLoginStatus()
    .then(data => {
        const name = _.get(data, 'data.displayName');
        const HiddenItem = queryDom('.hidden-item')[0];
        // 已经登录 hidden-item（登录状态下应该显示） 无active状态，去掉active状态
        // 未登录 初始情况就是未登录 忽略
        HiddenItem.className.includes('active') && _.each(queryDom('.hidden-item'), item => {
            addActiveClass(item);
        });
        queryDom('#logout')[0] && (queryDom('#logout')[0].innerText = name.slice(0, 1));
        queryDom('#userName')[0] && (queryDom('#userName')[0].innerText = name);
        // 判断地区
        if (isZH) {
            // 是否激活
            const active = localStorage.getItem('brtc-active-status');
            if (!active) {
                client.activeService()
                .then(() => {
                    // 视频会议是否激活标志
                    localStorage.setItem('brtc-active-status', 'ready');
                });
            }
        }
    });
}

(function () {
    active();

    window.onpopstate = event => {
        // 监听路由改变 重新拉下用户名
        active();
    };
    let isHangStyle = false;
    const checkScroll = () => {
        if (document.documentElement.scrollTop > 20) {
            if (!isHangStyle) {
                isHangStyle = true;
                const body = document.body;
                let className = body.className;
                body.className = className + ' scrolling';
            }
        } else if (isHangStyle) {
            isHangStyle = false;
            const body = document.body;
            let className = body.className;
            body.className = className.replace('scrolling', '');
        }
    };

    checkScroll();
    addEvent(document, 'scroll', checkScroll);
})();
